import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';

const useStyles = makeStyles((theme) => ({
  stars: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));
const UserRank = ({ user }) => {
  const classes = useStyles();
  return (
    <div className={classes.stars}>
      <Rating
        name="size-small"
        defaultValue={user.rank ? user.rank : 0}
        size="small"
        disabled
      />
      <span style={{ marginRight: 10 }}>{user.rank ? user.rank : 0}</span>
    </div>
  );
};

export default UserRank;
